<template>
  <div>

    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>薪资管理</el-breadcrumb-item>
      <el-breadcrumb-item>薪资查询</el-breadcrumb-item>
    </el-breadcrumb>


    <el-card>

      <!-- 搜索 添加 -->
      <div>
        <el-row>
          <el-tag>{{excelTaskCategory.salaryYear}}年{{excelTaskCategory.salaryMonth}}月-{{excelTaskCategory.customTypeName}}</el-tag>
        </el-row>
      </div>


      <el-row style="margin-top: 10px" :gutter="20">
        <el-form>

        <el-col :span="7">
          <el-input class="input-with-select" placeholder="请输入查询信息" v-model="form.selectContent" clearable @clear="queryMonthSalaryListV2">     <!-- clearable可清空搜索数据之后返回整体的菜单 -->
            <el-select style="width:100px"  v-model="form.selectType" slot="prepend" placeholder="请选择">
              <el-option label="手机号" value="1"></el-option>
              <el-option label="身份证" value="2"></el-option>
            </el-select>
          </el-input>
        </el-col>

        <el-col :span="4">
          <el-form-item label="查看状态:">
            <el-select style="width:100px" v-model="form.lookStatus"  placeholder="请选择">
              <el-option label="全部" value="-999"></el-option>
              <el-option label="未查看" value="0"></el-option>
              <el-option label="已查看" value="1"></el-option>
              <el-option label="已确认" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="1">
          <el-button type="primary"  @click="queryMonthSalaryListV2">查询</el-button>
        </el-col>


          <el-col :offset="1" :span="1">
            <el-button type="warning"  @click="queryMonthSalaryListV2Export">导出</el-button>
          </el-col>
        </el-form>
      </el-row>


      <el-table style="width: 100%" border :data="salaryList"  >
      <template v-for="(item,index) in columnList">
        <el-table-column :prop="item.columnNumber" :label="item.categoryName" :key="index" v-if="item.categoryName != 'id'">
        </el-table-column>
      </template>
    </el-table>
      <!--  分页区域-->
      <el-pagination
        @size-change = "handleSizeChange"
        @current-change = "handleCurrentChange"
        :current-page = "form.page"
        :page-sizes = "[50,100]"
        :page-size = "form.limit"
        layout = "sizes,total,prev, pager, next, jumper"
        :total = "total">
      </el-pagination>


    </el-card>
  </div>
</template>

<script>

  let Base64 = require('js-base64').Base64

  export default {
    props: ['id'],
    data() {
      return {
        form: {
          excelTaskCategoryId:null,
          page:1,
          limit:20,
          selectType:"1",
          selectContent:"",
          lookStatus:"-999"
        },
        columnList:[],// 表格数据
        salaryList: [],
        excelTaskCategory:null,
        total:0,
      };
    },

    methods: {
      async queryMonthSalaryListV2(){
        this.form.exportFlag = false;
        const { data: res } = await this.$http.post('/mainSalary/queryMonthSalaryListV2',this.form)   //get参数用params获得
        if(res.code !== '10000') {
          return this.$message.error(res.msg);
        }

        this.columnList = res.data.columnList;
        this.salaryList = res.data.salaryList;
        this.excelTaskCategory = res.data.excelTaskCategory;
        this.total = res.data.total;
      },
      async queryMonthSalaryListV2Export(){
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        setTimeout(() => {
          loading.close();
        }, 5000);

        this.form.exportFlag = true;
        const { data: res } = await this.$http.post('/mainSalary/queryMonthSalaryListV2',this.form)   //get参数用params获得
        if(res.code !== '10000') {
          loading.close();
          return this.$message.error(res.msg);
        }
        this.url = res.data.url;
        window.location.href=res.data.url;

        loading.close();

        this.$message.success("导出成功!");
      },
      // 监听 页码值 的改变
      handleCurrentChange(newPage) {
        // console.log(newPage)
        this.form.page = newPage
        this.queryMonthSalaryListV2()
      },
      handleSizeChange(newSize){
        this.form.limit = newSize
        this.queryMonthSalaryListV2()
      }
    },
    created () {
      this.form.excelTaskCategoryId =parseInt(Base64.decode(this.id+""));

      this.queryMonthSalaryListV2();
    },
  }
</script>

<style lang="less" scoped>
  .el-card-define {
    min-height: 100%;
    height: 100%;

  }

  .demo-form-inline{
    margin-top: 20px;
  }


</style>



// WEBPACK FOOTER //
// src/components/salary/SalaryDetails.vue